import React, { useEffect, useState } from 'react';
import { Route, Switch } from 'react-router';
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Link } from 'react-router-dom';
import UserStatus from '../user/UserStatus';
import PageNotFound from '../PageNotFound';
import RouteViewerPage from '../routes/RouteViewerPage';
import './Layout.css';
import { checkLogin } from '../../redux/actions/authActions';
import LoadingPage from "../common/LoadingPage";
import TermsAndConditions from '../TermsAndConditions';
import PrivacyPolicy from '../PrivacyPolicy';
import Cookies from '../Cookies';
import About from '../About';
import InfoLayout from './InfoLayout';
import CreateRoutePage from '../routes/CreateRoutePage';

function ExternalOpenLayout(
    {
        user,
        checkLogin,
        history,
        ...props
    }
) {

    const [processing, setProcessing] = useState(true);

    useEffect(() => {
        if (!user || !user.id) {
            checkLogin()
                .then((result) => {
                    if (!result.isAuthenticated) {
                        setProcessing(false);
                    }
                    else {
                        var route = props.location.pathname.split("/");
                        if (route[1] === "about") {
                            setProcessing(false);
                            return; 
                        }
                        if (route[2] === "routes" && !isNaN(route[3])) {
                            history.push(`/routes/${route[3]}`);
                            return;
                        }
                        if (route[2] === "routes" && route[3] == "create") {
                            history.push(`/routes/create`);
                            return;
                        }
                        history.push(`/dashboard`);
                    }
                })
        }
        else {
            setProcessing(false);
        }
    }, [])


    return (
        processing ?
            <LoadingPage />
            :
            <React.Fragment>
                <nav className="navbar navbar-dark fixed-top bg-dark flex-md-nowrap p-0 shadow">
                    <Link to="/" className="navbar-brand navbar-left">
                        <img className="siteLogo" src="/resources/images/logo.png" alt="JustGoRide" />
                    </Link>
                    <ul className="navbar-nav px-3">
                        <li className="nav-item navbar-right">
                            <UserStatus />
                        </li>
                    </ul>
                </nav>
                <Switch>
                    <Route path='/ext/routes/create' component={CreateRoutePage} />
                    <Route path='/ext/routes/:id' component={RouteViewerPage} />
                    <Route path='/about' component={InfoLayout} />
                    <Route component={PageNotFound} />
                </Switch>
            </React.Fragment>
      
    );
}


ExternalOpenLayout.propTypes =
{
    user: PropTypes.object,
    checkLogin: PropTypes.func.isRequired
}

function mapStateToProps(state) {
    return {
        user: state.user
    };
}

const mapDispatchToProps = {
    checkLogin
}

export default connect(mapStateToProps, mapDispatchToProps)(ExternalOpenLayout);






// WEBPACK FOOTER //
// ./src/components/common/ExternalOpenLayout.js